import { SplitsTeamsWordmark } from '~/components/SplitsTeamsWordmark'
import { SignInButton } from '~/components/auth/SignInButton'
import { Button } from '~/components/component-library'

interface AuthenticateCTAProps {
  header?: string
  description?: string
}

export const AuthenticateCTA = ({
  header,
  description = 'Fast, flexible, and fully in your control. Manage accounts, teammates, and workflows seamlessly across Ethereum.',
}: AuthenticateCTAProps) => {
  return (
    <div className="flex flex-col space-y-2 rounded-2xl bg-gray-50 p-6 dark:border dark:border-gray-800 dark:bg-black">
      <SplitsTeamsWordmark size="sm" />
      <div className="flex flex-col space-y-6">
        <div className="space-y-4">
          <h1>
            {header || (
              <>
                Modern banking,
                <br />
                on Ethereum.
              </>
            )}
          </h1>
          <p>{description}</p>
        </div>
        <div className="flex gap-2">
          <SignInButton />
          <Button
            variant="secondary"
            href={{ path: 'https://splits.org/teams/', target: 'tab' }}
          >
            Learn more
          </Button>
        </div>
      </div>
    </div>
  )
}
